import React from 'react';

import { HFS_PRIVACY_POLICY_URL } from 'constants/constants';
import Checkbox from 'components/common/Checkbox/Checkbox';

import styles from './Consent.module.scss';

interface ConsentElementProps {
  isShowTransactionalConsent: boolean;
  onChange: () => void;
  errorMessage?: string;
}

const CONSENT_TEXT = `You expressly consent to receiving calls and messages, including auto-dialed and pre-recorded message calls,
 and SMS messages (including text messages) from HFS Financial at any telephone numbers that you have provided or may provide
 in the future (including any cellular telephone numbers).  HFS Financial may send text messages in various formats and with
 various contents, including but not limited to, text messages about products, services, and transactions you have requested/initiated;
 and/or marketing the products and services offered by or through us. You are the owner or authorized user of the mobile phone number
 you have provided and you will notify us immediately if you are no longer the owner or authorized user of the mobile phone number
 you have provided. Your cellular or mobile telephone provider will charge you according to the type of plan you carry.`;

const Consent = ({ isShowTransactionalConsent, onChange, errorMessage }: ConsentElementProps) => {
  if (isShowTransactionalConsent) {
    return (
      <div>
        <p className={styles.consentText}>
          I agree to receive text messages from HFS Financial, LLC at the phone number provided. These messages may
          include transactional communications, status updates, and appointment reminders. Message frequency may vary.
          Standard message and data rates may apply. Reply STOP at any time to unsubscribe. For help, reply HELP or
          contact us at 800-254-9560. Please review our{' '}
          <a href={HFS_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{' '}
          to learn how your data is used.
        </p>
        <Checkbox
          onChange={onChange}
          errorMessage={errorMessage}
          className={styles.consentCheckbox}
          label={<p className={styles.consentLabel}>{CONSENT_TEXT}</p>}
        />
      </div>
    );
  }

  return <p className={styles.consentLabel}>{CONSENT_TEXT}</p>;
};

export default Consent;
